// Dynamiczne ładowanie stylów i skryptów dla bloków
try {
    // style.scss z /template/blocks/**
    const contextStyles = require.context(
        '../template/blocks',
        true,
        /style\.scss$/
    );

    if (contextStyles && typeof contextStyles.keys === 'function') {
        contextStyles.keys().forEach(key => contextStyles(key));
    }

    // view.js z /template/blocks/**
    const contextFrontScripts = require.context(
        '../template/blocks',
        true,
        /view\.js$/
    );

    if (contextFrontScripts && typeof contextFrontScripts.keys === 'function') {
        contextFrontScripts.keys().forEach(key => contextFrontScripts(key));
    }

    // style.scss z /template/acf-blocks/**
    const contextStylesAcf = require.context(
        '../template/acf-block',
        true,
        /style\.scss$/
    );

    if (contextStylesAcf && typeof contextStylesAcf.keys === 'function') {
        contextStylesAcf.keys().forEach(key => contextStylesAcf(key));
    }

    // view.js z /template/acf-blocks/**
    const contextFrontScriptsAcf = require.context(
        '../template/acf-block',
        true,
        /view\.js$/
    );

    if (contextFrontScriptsAcf && typeof contextFrontScriptsAcf.keys === 'function') {
        contextFrontScriptsAcf.keys().forEach(key => contextFrontScriptsAcf(key));
    }




} catch (error) {
    console.error('Błąd ładowania bloków:', error);
}
